/**
 * Base URL for the AI module's MBC http. The review page talks to the AI
 * module directly (no backend hop) to read and persist the brief.
 * Origin-relative so the browser sends the httpOnly JWT cookie automatically
 * (same-origin behind CloudFront/ALB); proxied through Vite
 * ("/api/ai/v1" → Mastra server :4111) in local dev.
 */
export const MBC_AI_API_URL =
  import.meta.env.VITE_MBC_MASTRA_API_URL ?? "/api/ai/v1";
